module.exports = __webpack_public_path__ + "static/media/ic_categories_shoe.37d39f38.svg";